import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";

const removeMailItemWithDataMutator: (data: any) => void = mutatorAction("removeMailItemWithData", function (data: any): void {
    const delayStore = getStore();
    for (let i = 0; i < delayStore.delayedMailItems.length; i++) {
        if (delayStore.delayedMailItems[i].data == data) {
            delayStore.delayedMailItems.splice(i, 1);
            break;
        }
    }
});
export default removeMailItemWithDataMutator;
